module.exports = __webpack_public_path__ + "img/geocomposto2.a5355a82.png";